/* ═══════════════════════════════════════════════════
   NEWJAISA — EDTECH INDUSTRY PAGE
   File: assets/component-edtech.js
   Namespace: EdtechPage · No globals · No jQuery
═══════════════════════════════════════════════════ */

'use strict';

var EdtechPage = (function () {

  function $(id)   { return document.getElementById(id); }
  function $$(sel) { return Array.from(document.querySelectorAll(sel)); }

  /* ── PRICE TABLE ────────────────────────── */
  var PRICES = {
    desktop: { nj: 15000, np: 40000 },
    laptop:  { nj: 21000, np: 55000 },
    faculty: { nj: 26000, np: 65000 },
    premium: { nj: 36000, np: 90000 }
  };

  /* ── FORMAT INR ─────────────────────────── */
  function fmtINR(n) {
    if (n >= 10000000) return '₹' + (n / 10000000).toFixed(1) + 'Cr';
    if (n >= 100000)   return '₹' + (n / 100000).toFixed(1) + 'L';
    if (n >= 1000)     return '₹' + (n / 1000).toFixed(0) + 'K';
    return '₹' + n;
  }

  /* ── ROI CALCULATOR ─────────────────────── */
  function calcROI() {
    var qtyEl  = $('ed-roi-qty');
    var typeEl = $('ed-roi-type');
    if (!qtyEl || !typeEl) return;

    var qty    = parseInt(qtyEl.value) || 50;
    var d      = PRICES[typeEl.value] || PRICES.desktop;
    var totalNew = d.np * qty;
    var totalNJ  = d.nj * qty;
    var saving   = totalNew - totalNJ;
    var pct      = Math.round((saving / totalNew) * 100);

    var newEl  = $('ed-r-new');
    var njEl   = $('ed-r-nj');
    var saveEl = $('ed-r-save');

    if (newEl)  newEl.textContent  = fmtINR(totalNew);
    if (njEl)   njEl.textContent   = fmtINR(totalNJ);
    if (saveEl) saveEl.textContent = 'You Save ' + fmtINR(saving) + ' (' + pct + '%)';
  }

  /* ── FAQ ACCORDION ──────────────────────── */
  function initFAQ() {
    $$('.ed-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item   = btn.closest('.ed-faq-item');
        if (!item) return;
        var isOpen = item.classList.contains('open');

        $$('.ed-faq-item.open').forEach(function (i) {
          i.classList.remove('open');
          var q = i.querySelector('.ed-faq-q');
          if (q) q.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── SCROLL REVEAL ──────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.ed-reveal').forEach(function (el) { el.classList.add('ed-vis'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var parent   = entry.target.parentElement;
        var siblings = parent
          ? Array.from(parent.children).filter(function (el) {
              return el.classList.contains('ed-reveal') && !el.classList.contains('ed-vis');
            })
          : [];
        var idx = siblings.indexOf(entry.target);
        setTimeout(function () { entry.target.classList.add('ed-vis'); }, Math.max(0, idx * 80));
        io.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    $$('.ed-reveal').forEach(function (el) { io.observe(el); });
  }

  /* ── ANCHOR SMOOTH SCROLL ───────────────── */
  function initAnchors() {
    $$('a[href="#ed-cta"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var el = document.getElementById('ed-cta');
        if (!el) return;
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── GUIDE DOWNLOAD PLACEHOLDER ─────────── */
  function initDownloads() {
    var dlBtn = $('ed-dl-guide');
    if (dlBtn) {
      dlBtn.addEventListener('click', function () {
        alert('Downloading: Education Procurement Guide\n\nContact business@newjaisa.com to receive the full guide.');
      });
    }
  }

  /* ── INIT ───────────────────────────────── */
  function init() {
    /* ROI listeners */
    var qtyEl  = $('ed-roi-qty');
    var typeEl = $('ed-roi-type');
    if (qtyEl)  qtyEl.addEventListener('input',  calcROI);
    if (typeEl) typeEl.addEventListener('change', calcROI);
    calcROI();

    initFAQ();
    initReveal();
    initAnchors();
    initDownloads();
  }

  return { init: init };

})();

document.addEventListener('DOMContentLoaded', function () {
  EdtechPage.init();
});
